/**
 * Seeded admin list. On-chain AccessControl is the authority.
 *
 * Assigned admin wallets use the platform as Admin without an APTMDAO NFT
 * or a Global Standard DID. Applicant flows still require a live DID.
 */

import { REGISTRY_ADMINS } from './registryConfig';

export function parseAdminWallets(raw: string | undefined): Set<string> {
  const set = new Set<string>();
  for (const a of REGISTRY_ADMINS) set.add(a.toLowerCase());
  if (raw) {
    for (const part of raw.split(/[\s,]+/)) {
      const trimmed = part.trim().toLowerCase();
      if (trimmed.startsWith('0x') && trimmed.length === 42) set.add(trimmed);
    }
  }
  return set;
}

export function isAdminWallet(
  address: string | null | undefined,
  allowlist: Set<string> = parseAdminWallets(
    typeof import.meta !== 'undefined'
      ? import.meta.env.VITE_ADMIN_WALLETS
      : undefined
  )
): boolean {
  if (!address) return false;
  return allowlist.has(address.toLowerCase());
}

/** Assigned admins skip APTMDAO NFT + Global DID membership gates. */
export function isExemptFromMembershipGates(
  address: string | null | undefined,
  allowlist?: Set<string>
): boolean {
  return isAdminWallet(address, allowlist);
}
